module.exports = __webpack_public_path__ + "static/sergiler5-1f904d96429a8cf864344f150b945e72.png";